
<!-- <h3 class="heading text-a-center d-b">Organization Hierarchy</h3> -->


<div class="text-a-center"> 
  <nz-radio-group [nzButtonStyle]="'solid'" [(ngModel)]="selectedHierarchy">
    <label nz-radio-button nzValue="ORG" selected >Whole Org</label>
    <label nz-radio-button nzValue="USER" >My Vertical</label>
  </nz-radio-group>
</div>
<div class="text-a-center">
  <div [hidden]="!(selectedHierarchy == 'USER' && hierarchyData && showChart)">
    <div #chartuserContainer></div>
  </div>
  <div [hidden]="!(selectedHierarchy == 'ORG' && orgHierarchyData && showChart)">
    <div #chartOrgContainer></div>
  </div>
</div>
